import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {iProductAvailability} from "../model/ProductAvailabilityModel";

@Injectable({
  providedIn: 'root'
})
export class ProductAvailabilityService {

  private availabilityURL = environment.links.availability.response;

  private httpOptions = {
    headers: new HttpHeaders({
      "X-CSRF-TOKEN": window['ACC']['config']['CSRFToken']
    })
  };

  constructor(private http: HttpClient) {}

  getData(_productCode) {
    const productCode = _productCode;

    return this.http.get<iProductAvailability>(`${this.availabilityURL}${productCode}`, this.httpOptions);
  }
}
